import { type UseMutationResult, useMutation, useQueryClient } from 'react-query';
import { toast } from 'react-toastify';
import ToastComponent from '../../components/toast';
import {
  type Wealthlane_Shared_Hosting_Dtos_GenericApiResponse,
} from '@wealthlane/api-services/wealthlane-identity-service';
import { TrustedDeviceService } from '@wealthlane/api-services/wealthlane-identity-service';

const usePostRevokeAllTrustedDevices = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  closeModal: () => void
): UseMutationResult<
  Wealthlane_Shared_Hosting_Dtos_GenericApiResponse | undefined,
  unknown,
  void,
  unknown
> => {
  const queryClient = useQueryClient();

  return useMutation(
    async () => {
      return await handleRequest(
        TrustedDeviceService.postApiIdentityApiAppTrustedDeviceRevokeAll()
      );
    },
    {
      onSuccess: (response: any) => {
        if (response != null) {
          toast.success(
            <ToastComponent label='Success' message={response?.message ?? 'All trusted devices have been revoked.'} />
          );
          void queryClient.invalidateQueries('getTrustedDevices');
          closeModal();
        }
      },
      onError: (err) => {
        console.log('error', err);
      },
    }
  );
};

export default usePostRevokeAllTrustedDevices;
